module.exports = __webpack_public_path__ + "img/lc_hyzs.50cdab69.svg";